<template>
    <default-item class="menu--item-wv_steak_house_wine" :item="item" :show-bin="showBin" :pricing-types="pricingTypes"></default-item>
</template>

<script lang="ts">
/**
 * Custom component for WV Steak House food items.
 *
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 1.0.1
 * @copyright  Copyright (C) 2023-2025, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *
 *    2023-08-29 (1.0.0) (jhoward)
 *      - <WVSteakHouseFoodItem> copied to <WVSteakHouseWineListItem>.
 *
 *    2025-04-08 (1.0.1) (jhoward)
 *      - Remove "visual_" prefix from class names in <WVSteakHouseWineListItem>.
 */

import {defineComponent, PropType} from "vue";
import {MenuItem} from "../defs";
import DefaultItem from "./defaultItem.vue";

export default defineComponent({
  name: 'WVSteakHouseWineListItem',
  components: {
    DefaultItem
  },
  props: {
    item: {
      type: Object as PropType<MenuItem>,
      required: true
    },
    showBin: {
      type: Boolean,
      default: false
    },
    pricingTypes: {
      type: Array as PropType<string[]>,
      default: () => []
    }
  },
})
</script>

<style scoped>

</style>